@if (isOpen()) {
  <div class="confirm-overlay" (click)="onCancel()" (keydown.escape)="onCancel()" aria-hidden="true"></div>
  <div class="confirm-dialog"
       role="alertdialog"
       aria-modal="true"
       aria-labelledby="confirm-dialog-title"
       aria-describedby="confirm-dialog-message">
    <p id="confirm-dialog-title" class="confirm-title">Are you sure?</p>
    <p id="confirm-dialog-message" class="confirm-message">{{ message() }}</p>
    <div class="confirm-actions">
      <button type="button" class="btn-cancel" (click)="onCancel()">{{ cancelLabel() }}</button>
      <button type="button" class="btn-confirm" (click)="onConfirm()">{{ confirmLabel() }}</button>
    </div>
  </div>
}
